import {useEffect} from 'react';

import {Container} from '@/components/HotelsPageLayoutMapOverlay/components/Container';
import {LayerPortal} from '@/components/LayerPortal';

type Props = {
  controlBar?: null | React.ReactNode;
  map?: null | React.ReactNode;
  isMapVisible: boolean;
};

export const HotelsPageLayoutMapOverlay: React.FunctionComponent<Props> = ({
  controlBar,
  map,
  isMapVisible,
}) => {
  // wheeling (is that a word?) over a non google maps controlled element (like the hotel tile),
  // would cause the underlying page to scroll due to event bubbling => prevent that default behavior.
  useEffect(() => {
    const handler = (event: WheelEvent) => {
      event.preventDefault();
    };
    if (isMapVisible) {
      window.addEventListener('wheel', handler, {passive: false});
    }
    return () => {
      // note: no-op if map never was visible (just unmounting)
      window.removeEventListener('wheel', handler);
    };
  }, [isMapVisible]);

  return (
    <LayerPortal>
      <Container isMapVisible={isMapVisible}>
        {controlBar}
        {map}
      </Container>
    </LayerPortal>
  );
};
